<template>
  <div
    id="header"
    class="navbar navbar-expand-lg navbar-fixed navbar-height navbar-container navbar-bordered bg-white"
  >
    <div class="navbar-nav-wrap">
      <!-- Logo -->

      <!-- End Logo -->

      <div class="navbar-nav-wrap-content-start">
        <!-- Navbar Vertical Toggle -->
        <i
          v-if="showMenu"
          class="bi bi-list text-dark"
          style="font-size: 21px; transition: all 0.5s"
          :style="[componentValue ? { transform: 'rotate(90deg)' } : {}]"
          @click="change()"
        ></i>

        <!-- Search Form -->
        <div class="dropdown ms-2">
          <!-- End Input Group -->

          <!-- Card Search Content -->
          <div
            id="searchDropdownMenu"
            class="hs-form-search-menu-content dropdown-menu dropdown-menu-form-search navbar-dropdown-menu-borderless"
          >
            <!-- Body -->
            <div class="card-body-height">
              <div class="d-lg-none">
                <div
                  class="input-group input-group-merge navbar-input-group mb-5"
                >
                  <div class="input-group-prepend input-group-text">
                    <i class="bi-search"></i>
                  </div>

                  <input
                    type="search"
                    class="form-control"
                    placeholder="Search in front"
                    aria-label="Search in front"
                  />
                  <a
                    class="input-group-append input-group-text"
                    href="javascript:;"
                  >
                    <i class="bi-x-lg"></i>
                  </a>
                </div>
              </div>

              <span class="dropdown-header">Recent searches</span>

              <div class="dropdown-item bg-transparent text-wrap">
                <a
                  class="btn btn-soft-dark btn-xs rounded-pill"
                  href="index.htm"
                >
                  Gulp <i class="bi-search ms-1"></i>
                </a>
                <a
                  class="btn btn-soft-dark btn-xs rounded-pill"
                  href="index.htm"
                >
                  Notification panel <i class="bi-search ms-1"></i>
                </a>
              </div>

              <div class="dropdown-divider"></div>

              <span class="dropdown-header">Tutorials</span>

              <a class="dropdown-item" href="index.htm">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0">
                    <span class="icon icon-soft-dark icon-xs icon-circle">
                      <i class="bi-sliders"></i>
                    </span>
                  </div>

                  <div class="flex-grow-1 text-truncate ms-2">
                    <span>How to set up Gulp?</span>
                  </div>
                </div>
              </a>

              <a class="dropdown-item" href="index.htm">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0">
                    <span class="icon icon-soft-dark icon-xs icon-circle">
                      <i class="bi-paint-bucket"></i>
                    </span>
                  </div>

                  <div class="flex-grow-1 text-truncate ms-2">
                    <span>How to change theme color?</span>
                  </div>
                </div>
              </a>

              <div class="dropdown-divider"></div>

              <span class="dropdown-header">Members</span>

              <a class="dropdown-item" href="index.htm">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0">
                    <img
                      class="avatar avatar-xs avatar-circle"
                      src="/assets/img/160x160/img10.jpg"
                      alt="Image Description"
                    />
                  </div>
                  <div class="flex-grow-1 text-truncate ms-2">
                    <span
                      >Amanda Harvey
                      <i
                        class="tio-verified text-primary"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Top endorsed"
                      ></i
                    ></span>
                  </div>
                </div>
              </a>

              <a class="dropdown-item" href="index.htm">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0">
                    <img
                      class="avatar avatar-xs avatar-circle"
                      src="/assets/img/160x160/mr.jpg"
                      alt="Image Description"
                    />
                  </div>
                  <div class="flex-grow-1 text-truncate ms-2">
                    <span>David Harrison</span>
                  </div>
                </div>
              </a>

              <a class="dropdown-item" href="index.htm">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0">
                    <div
                      class="avatar avatar-xs avatar-soft-info avatar-circle"
                    >
                      <span class="avatar-initials">A</span>
                    </div>
                  </div>
                  <div class="flex-grow-1 text-truncate ms-2">
                    <span>Anne Richard</span>
                  </div>
                </div>
              </a>
            </div>
            <!-- End Body -->

            <!-- Footer -->
            <a class="card-footer text-center" href="index.htm">
              See all results <i class="bi-chevron-right small"></i>
            </a>
            <!-- End Footer -->
          </div>
          <!-- End Card Search Content -->
        </div>

        <!-- End Search Form -->
      </div>

      <div class="navbar-nav-wrap-content-end">
        <!-- Navbar -->
        <ul class="navbar-nav">
          <li class="nav-item d-none d-sm-inline-block">
            <!-- Notification -->
            <div class="dropdown">
              <button
                type="button"
                class="btn btn-ghost-secondary btn-icon rounded-circle"
                id=""
                data-bs-toggle="dropdown"
                aria-expanded="false"
                data-bs-auto-close="outside"
                data-bs-dropdown-animation
              >
                <i class="bi-bell"></i>
                <div
                  class="btn-status btn-sm-status btn-status-danger spinner-grow text-warning spinner-grow-sm"
                  v-if="trrigerEvent"
                  style="margin-left: -21px"
                  role="status"
                ></div>
              </button>
            </div>
            <!-- End Notification -->
          </li>

          <li class="nav-item d-none d-sm-inline-block">
            <!-- Notification -->
            <div class="dropdown">
              <router-link
                :to="{ name: 'PanelUser-Cart' }"
                class="btn btn-ghost-secondary btn-icon rounded-circle"
              >
                <i class="bi-cart"></i>
                <div
                  class="btn-status btn-sm-status btn-status-danger spinner-grow text-danger spinner-grow-sm"
                  v-if="trrigerAlert"
                  style="margin-left: -21px"
                  role="status"
                ></div>
              </router-link>
            </div>
            <!-- End Notification -->
          </li>

          <li class="nav-item">
            <!-- Account -->
            <div class="user-header__dropdown">
              <button
                ref="accountTrigger"
                type="button"
                class="navbar-profile-menu_trigger"
                :aria-expanded="accountMenuOpen ? 'true' : 'false'"
                aria-label="منوی حساب کاربری"
                @click="toggleAccountMenu"
              >
                <div class="user-header__account-avatar avatar avatar-sm avatar-circle">
                  <img
                    class="avatar-img"
                    src="/assets/jpg/1.jpg"
                    alt="Image Description"
                  />
                  <span
                    class="avatar-status avatar-sm-status avatar-status-success"
                  ></span>
                </div>

                <div class="user-header__account-meta d-none d-md-flex">
                  <strong class="user-header__account-title">پروفایل</strong>
                  <span class="user-header__account-name">
                    {{ fullName }}
                  </span>
                </div>

                <i
                  class="bi bi-chevron-down user-header__account-chevron"
                  :class="{ 'user-header__account-chevron--open': accountMenuOpen }"
                ></i>
              </button>

              <div
                ref="accountPanel"
                class="user-header__account-panel"
                :class="{ 'user-header__account-panel--open': accountMenuOpen }"
              >
                <div class="user-header__account-summary">
                  <div class="avatar avatar-sm avatar-circle">
                    <img
                      class="avatar-img"
                      src="/assets/jpg/1.jpg"
                      alt="Image Description"
                    />
                  </div>
                  <div class="user-header__account-summary-text">
                    <h5>کاربر گرامی</h5>
                    <p>{{ fullName }}</p>
                  </div>
                </div>

                <router-link
                  class="user-header__account-link"
                  :to="{ name: 'PanelUser-Profile' }"
                  @click="closeAllMenus"
                >
                  <i class="bi bi-person-circle"></i>
                  <span>پروفایل</span>
                </router-link>

                <router-link
                  class="user-header__account-link user-header__account-link--danger"
                  :to="{ name: 'PanelUser-Logout' }"
                  @click="closeAllMenus"
                >
                  <i class="bi bi-box-arrow-right"></i>
                  <span>خروج</span>
                </router-link>
              </div>
            </div>
            <!-- End Account -->
          </li>
        </ul>
        <!-- End Navbar -->
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";

import jmoment from "jalali-moment";

import { toastSuccess, toastWarning, toastError } from "@/utils/toast";

export default {
  props: ["modelValue", "showMenu"],
  emits: ["update:modelValue"],
  data() {
    return {
      alerts: [],
      alertsEdit: [],
      events: [],
      dataItem: {
        firstName: "",
        lastName: "",
      },
      eventsEdit: [],
      trrigerEvent: false,
      trrigerAlert: false,
      nowDataTime: "",
      serverBaseUrl: axios.defaults.baseURL,
      accountMenuOpen: false,
    };
  },
  computed: {
    componentValue: {
      get() {
        return this.modelValue;
      },
      set(componentValue) {
        this.$emit("update:modelValue", componentValue);
      },
    },
    fullName() {
      const firstName = this.dataItem.firstName || "";
      const lastName = this.dataItem.lastName || "";
      const fullName = `${firstName} ${lastName}`.trim();

      return fullName || "کاربر گرامی";
    },
  },

  methods: {
    change() {
      if (this.componentValue) {
        this.componentValue = false;
      } else {
        this.componentValue = true;
      }
    },
    toggleAccountMenu() {
      this.accountMenuOpen = !this.accountMenuOpen;
    },
    closeAllMenus() {
      this.accountMenuOpen = false;
    },
    handleOutsideClick(event) {
      if (
        this.$refs.accountPanel?.contains(event.target) ||
        this.$refs.accountTrigger?.contains(event.target)
      ) {
        return;
      }

      this.closeAllMenus();
    },
  },

  created() {},

  mounted() {
    this.dataItem = this.$store.state.userDetails;
    document.addEventListener("click", this.handleOutsideClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
};
</script>
<style>
.blink {
  animation: blink-animation 0.5s steps(2, start) infinite;
  -webkit-animation: blink-animation 0.5s steps(2, start) infinite;
}
@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}

.user-header__dropdown {
  position: relative;
}

button.navbar-profile-menu_trigger {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  min-height: 48px;
  padding: 0.45rem 0.75rem;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 16px;
  background: #fff;
  color: #0f172a;
  box-shadow: 0 16px 32px -24px rgba(15, 23, 42, 0.35);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

button.navbar-profile-menu_trigger:hover {
  border-color: rgba(245, 158, 11, 0.4);
  box-shadow: 0 20px 40px -28px rgba(15, 23, 42, 0.42);
}

.user-header__account-avatar {
  flex-shrink: 0;
}

.user-header__account-meta {
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  line-height: 1.2;
}

.user-header__account-title {
  font-size: 0.76rem;
  color: #64748b;
}

.user-header__account-name {
  font-size: 0.88rem;
  font-weight: 700;
  color: #0f172a;
  max-width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-header__account-chevron {
  color: #64748b;
  transition: transform 0.2s ease;
}

.user-header__account-chevron--open {
  transform: rotate(180deg);
}

.user-header__account-panel {
  position: absolute;
  top: calc(100% + 12px);
  left: 0;
  z-index: 1045;
  width: 220px;
  padding: 0.7rem;
  border-radius: 20px;
  background: #fff;
  border: 1px solid rgba(226, 232, 240, 0.95);
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18);
  display: block;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.25s ease;
  pointer-events: none;
}

.user-header__account-panel::before {
  content: "";
  position: absolute;
  top: -15px;
  left: 0;
  right: 0;
  height: 15px;
  background: transparent;
}

@media (min-width: 992px) {
  .user-header__dropdown:hover .user-header__account-panel {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
    pointer-events: auto;
  }
}

.user-header__account-panel--open {
  opacity: 1 !important;
  visibility: visible !important;
  transform: translateY(0) !important;
  pointer-events: auto !important;
}

.user-header__account-summary {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.35rem 0.35rem 0.75rem;
  margin-bottom: 0.35rem;
  border-bottom: 1px solid rgba(226, 232, 240, 0.9);
}

.user-header__account-summary-text {
  text-align: right;
}

.user-header__account-summary-text h5 {
  margin: 0;
  font-size: 0.9rem;
  color: #0f172a;
}

.user-header__account-summary-text p {
  margin: 0.15rem 0 0;
  color: #64748b;
  font-size: 0.8rem;
}

.user-header__account-link {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.6rem;
  width: 100%;
  text-decoration: none;
  color: #0f172a;
  border-radius: 14px;
  padding: 0.78rem 0.9rem;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.user-header__account-link:hover {
  background: rgba(148, 163, 184, 0.12);
  color: #0f172a;
}

.user-header__account-link--danger {
  color: #b91c1c;
}

.user-header__account-link--danger:hover {
  background: rgba(239, 68, 68, 0.08);
  color: #991b1b;
}

@media (max-width: 768px) {
  .user-header__account-panel {
    position: fixed;
    top: 72px;
    left: 1rem;
    width: calc(100vw - 2rem);
    max-width: 260px;
  }

  button.navbar-profile-menu_trigger {
    padding: 0.45rem 0.6rem;
  }
}
</style>
